/**
 *  Brand constants — single source of truth for client / property brand
 *  display strings that appear in structured metadata across the site
 *  (project cards, testimonial attributions, industry chip strips).
 *
 *  Purpose: a future rebrand or spelling change should be a one-line
 *  edit here, not a search-and-replace across content files. Slugs,
 *  asset paths and backend seed data are IDENTIFIERS (not display
 *  names) and intentionally stay hard-coded at their call sites.
 *
 *  Verbatim narrative copy (testimonial body text, article prose,
 *  video captions) is intentionally NOT refactored here — those are
 *  quotations and stylistic writing where readability trumps
 *  renameability. Only structured metadata fields import from BRANDS.
 * ---------------------------------------------------------------------
 */

export const BRANDS = {
  thornybush: {
    // Full display name used in card headers and testimonial attributions.
    name: "Thornybush Game Lodge",
    // Short chip label used in client strips and marquees.
    short: "Thornybush",
    // Reserve name used in region / property-location fields.
    reserve: "Thornybush Private Nature Reserve",
    // URL slug — stays constant across a rename (identifier, not display).
    slug: "thornybush-game-lodge",
    // Official brand website.
    website: "https://www.thornybush.com/",
  },
};
